import Footer from "../Components/ui/footer";
import Header from "../Components/ui/header";
import { images } from "../Constants/imageslinks";

// This function now retrieves UTM parameters from sessionStorage
const getCurrentUTMParams = () => {
  const storedParams = sessionStorage.getItem("tracking_params");

  if (storedParams) {
    const parsedParams = JSON.parse(storedParams);
    const utmParams = new URLSearchParams();

    Object.entries(parsedParams).forEach(([key, value]) => {
      utmParams.set(key, value);
    });

    return utmParams.toString() ? `?${utmParams.toString()}` : "";
  }

  // Fallback to reading from the URL if sessionStorage is empty
  const urlParams = new URLSearchParams(window.location.search);
  const utmKeys = ["utm_source", "utm_medium", "utm_campaign", "utm_id"];
  const utmParams = new URLSearchParams();

  utmKeys.forEach((key) => {
    if (urlParams.has(key)) {
      utmParams.set(key, urlParams.get(key));
    }
  });

  return utmParams.toString() ? `?${utmParams.toString()}` : "";
};

const socialMediaDetails = [
  {
    href: "https://www.instagram.com/minimisphone/",
    icon: images.instagram,
    alt: "instagram icon",
  },
  {
    href: "https://www.linkedin.com/company/minimis-technologies",
    icon: images.linkedIn,
    alt: "linkedin icon",
  },
  {
    href: "https://www.facebook.com/minimistech",
    icon: images.facebook,
    alt: "facebook icon",
  },
];

const socialMedia = socialMediaDetails.map((social, index) => (
  <a href={social.href} target="_blank" rel="noopener noreferrer" key={index}>
    <img src={social.icon} alt={social.alt} />
  </a>
));

const ConfirmationPageComponent = () => {
  const handleMainMenuClick = () => {
    // Download Tracker
    if (window.twq) {
      window.twq("event", "tw-qmokf-qmoki", {
        content_name: "Minimis iOS App",
      });
    }

    setTimeout(() => {
      const baseUrl =
        "https://apps.apple.com/us/app/minimis-phone/id6742091169";
      window.open(`${baseUrl}${getCurrentUTMParams()}`, "_blank");
    }, 700);
  };

  return (
    <>
      <div>
        <div className="bg-primary200">
          <div className="lg:hidden">
            <Header />
          </div>
          <div className="block lg:hidden bg-primary100 md:px-8 px-4 pb-4 pt-5 md:pt-0">
            <div className="ml-7 flex items-center justify-start">
              <img src={images.early_access_icon} alt="deposit icon" />

              <div className="sm:w-[122px] w-[110px] h-0.5 bg-secondary100" />

              <img src={images.early_access_icon} alt="payment icon" />

              <div className="sm:w-[122px] w-[110px] h-0.5 bg-secondary100" />

              <img src={images.checkout_icon} alt="confirm icon" />
            </div>

            <div className="flex gap-22 relative mt-2 justify-start">
              <p className="font-inter font-light text-sm leading-3.5 whitespace-nowrap	">
                iOS Access
              </p>
              <p className="font-inter font-light text-sm leading-3.5 sm:ml-[77px] ml-[65px]">
                Checkout
              </p>
              <p className="font-inter font-medium text-sm leading-3.5 text-dark-100 sm:ml-[74px] ml-[62px]">
                Confirmation
              </p>
            </div>
          </div>
          <div className="3xl:container 3xl:mx-auto bg-primary300 lg:grid grid-cols-12 flex flex-col-reverse">
            <div className="lg:min-h-screen lg:px-[7vw] md:px-8 px-4 3xl:px-[110px] col-span-7">
              <div className="py-[45px] hidden lg:block">
                <img src={images.minimis_logo} alt="minimis logo" />
              </div>

              <div className="flex flex-col gap-14">
                <div className="lg:block hidden">
                  <div className=" ml-7 flex items-center justify-start">
                    <img src={images.early_access_icon} alt="deposit icon" />

                    <div className="lg:w-[122px] md:w-[100px] w-[60px] h-0.5 bg-secondary100" />

                    <img src={images.early_access_icon} alt="payment icon" />

                    <div className="w-[122px] h-0.5 bg-secondary100" />

                    <img src={images.checkout_icon} alt="confirm icon" />
                  </div>

                  <div className="flex gap-22 relative mt-2 justify-start">
                    <p className="font-inter font-light text-sm leading-3.5 text-secondary100">
                      iOS Access
                    </p>
                    <p className="font-inter font-light text-sm leading-3.5 ml-[78px] text-secondary100">
                      Checkout
                    </p>
                    <p className="font-inter font-medium text-sm leading-3.5 text-dark-100 ml-[74px] text-secondary100">
                      Confirmation
                    </p>
                  </div>
                </div>

                <div className="flex flex-col md:gap-16 gap-10 md:py-12 py-8 lg:py-0">
                  <div className="flex flex-col md:gap-3 gap-2">
                    <p className="font-light text-[32px] leading-12 text-secondary100">
                      Hello!
                    </p>
                    <div className="font-light text-base leading-6 text-secondary100 flex flex-col md:gap-6 gap-3 max-w-[499px]">
                      <p className="">
                        Thank you for gifting your friend a lifetime pass to
                        Minimis Phone. Your friend will receive an email with
                        below access instructions. Feel free to take a
                        screenshot of this page and send it to them.
                      </p>
                      <div className="bg-primary700 p-4 flex flex-col gap-3 md:mt-6 mt-4">
                        <p className="font-light leading-[21px]">
                          <span className="font-bold">Important:</span> Upon
                          installation, to redeem your access, please enter your
                          email address
                        </p>
                        <p>
                          If you run into any issues, please email us at{" "}
                          <a href="mailto:hey@minimis.co">hey@minimis.co</a>{" "}
                          :)
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-col gap-10">
                    {/*<div className="w-full max-w-[498px] bg-secondary100 rounded-sm text-center">
                      <button
                        onClick={handleMainMenuClick}
                        className="font-medium text-base leading-[100%] text-primary100 p-5"
                      >
                        Download
                      </button>
                    </div>*/}
                    <div className="flex gap-10 md:mt-12 mt-8">{socialMedia}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-span-5 bg-primary200 flex justify-center items-start lg:pt-36 pt-16">
              <img
                src={images.hero_image}
                alt="hero image"
                className="w-full max-w-[550px]"
              />
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default ConfirmationPageComponent;
